module.exports = __webpack_public_path__ + "img/ph.751d2bef.svg";